import * as yup from 'yup';

import localizedStrings from 'localization';

export const shareSubmissionSchema = yup.object().shape({
  message: yup.string().required(localizedStrings.shareMessageValidation),
});
